import React from "react"

const SectionInfoContent = ({ children }) => {
  return <div className="grid gap-y-2">{children}</div>
}

export default SectionInfoContent
